<template>
  <div>
	
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Add GPS</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
             <CCol sm="12" class="mb-3">										
                <!--<CSelect
                  label="Select Site"
                  :options="siteOptions"
                />-->
				<label class="m-0 col-fonts-black">Select Site</label>
				<v-select :options="siteOptions" placeholder="Select Site" @input="siteSel"></v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" class="mb-3">
                <!--<CInput
                  label="Customer Name"
                  placeholder="Enter customer name"
                />-->
				<label class="m-0 col-fonts-black">Select Customer</label>
				<v-select :options="customerOptions" placeholder="Select Customer" @input="customerSel"></v-select>
              </CCol>
            </CRow>
            <CRow class="mb-2 counterDiv">
              <CCol md="6">
                <CCard class="m-0">
                    <CListGroup>
                      <CListGroupItem
                        class="flex-column align-items-start pl-0 pr-0"
                      >
                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">Oldest O/S Amt</h5>
                              <p class="m-0 col-green fw-500">₹ <span id="oldest_os_amt">{{oldest_os_amt}}</span></p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Ageing Days</h5>
                              <p class="m-0 fw-500 col-fonts-grey"><span id="oldest_days">{{oldest_days}}</span></p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex p-0"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1 fw-500">Invoice Number</h5>
                              <p class="m-0 fw-500 col-fonts-grey"><span id="invoice_number">{{invoice_number}}</span></p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1"></h5>
                              <p class="m-0 fw-500 col-fonts-grey"></p>
                            </div>
                          </CCol>
                        </CCol>
                      </CListGroupItem>
                    </CListGroup>
                </CCard>
              </CCol>

              <CCol md="6">
                <CCard class="m-0">
                    <CListGroup>
                      <CListGroupItem
                        class="flex-column align-items-start pl-0 pr-0"
                      >
                        <CCol md="12" class="d-flex p-0 mb-3"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">OutStanding Amt</h5>
                              <p class="m-0 col-green fw-500">₹ <span id="outstanding_amt">{{outstanding_amt}}</span></p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Ageing info</h5>
                              <p class="m-0 fw-500"><u><i><a href="#" class="col-yellow">Click Here</a></i></u></p>
                            </div>
                          </CCol>
                        </CCol>

                        <CCol md="12" class="d-flex p-0"> 
                          <CCol md="6">
                            <div class="w-100">
                              <h5 class="mb-1">PCB Valid Upto</h5>
                              <p class="m-0 fw-500 col-fonts-grey">31-MAR-2020</p>
                            </div>
                          </CCol>

                          <CCol md="6"> 
                            <div class="w-100">
                              <h5 class="mb-1">Membership Valid Upto</h5>
                              <p class="m-0 fw-500 col-fonts-grey">01-AUG-2022</p>
                            </div>
                          </CCol>
                        </CCol>
                      </CListGroupItem>
                    </CListGroup>
                </CCard>
              </CCol>
            </CRow>
            <CRow>
             <CCol sm="12" class="mb-3">
                <!--<CSelect
                  label="Waste Name"
                  :options="wastename"
                />-->
				<label class="m-0 col-fonts-black">Waste Name</label>
				<v-select :options="wastename" placeholder="Select Waste Name" @input="wasteSel"></v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" class="p-0 d-flex">
                <CCol sm="3" class="mb-3">
                  <!--<CInput
                    label="Physical Status"
                    placeholder="LIQUID"
                  />-->
                <label class="m-0 col-fonts-black">Physical Status</label>
                <v-select :options="physicalOptions" placeholder="Select Status" @input="physicalSel"></v-select>
               </CCol>
              <CRow class="otherOptions col-sm-10">
               <CCol sm="2">
                  <CSelect
                  label="Month"
                  :options="wasteqty" id="wasteqty"
                />
               </CCol>

               <CCol sm="2">
                   <CSelect
                  label="Shipment"
                  :options="wasteshipment" id="shipmentid"
                />
               </CCol>

               <CCol sm="2">
                   <CSelect
                  label="Packaging"
                  :options="wastepackaging" id="wastepackaging"
                />
               </CCol>

               <CCol sm="2">
                   <CSelect
                  label="Texture"
                  :options="wastetexture" id="wastetexture"
                />
               </CCol>

               <CCol sm="2">
                   <CSelect
                  label="Truck Type"
                  :options="wastetrucktype" id="wastetrucktype"
                />
               </CCol>
              </CRow>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  label="Remarks"
                  placeholder="Content..."
                  verticle
                  rows="4"
                />
              </CCol>
            </CRow>
            <CRow>
			<CCol sm="6">
				<button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-light btn-block active fw-500 col-white fs-18" @click="back()">Cancel</button>
              </CCol>
              <CCol sm="6">
                <button aria-pressed="true" type="button" autocomplete="off" class="btn btn-outline-info btn-block active fw-500 col-white fs-18">Submit</button>
			</CCol>
			 
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
//import { ModelSelect } from 'vue-search-select';

export default {
  name: 'Add_GPS',
  data () {
    return {
      setSelected:"",
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label:'col-3', input:'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],     
	  siteOptions : [],
      physicalOptions : ['New physical','LIQUID'],
      customerOptions: [],
      wasteqty: ['1.0', '2.0', '3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0'],
      wasteshipment: [],
      wastepackaging: [],
      wastetexture: [],
      wastetrucktype: [],
      wastename: [],	
	  oldest_os_amt:0,
	  oldest_days:0,
	  invoice_number:0,
	  outstanding_amt:0,
	  
      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes',
                      'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios',
                    'Radios - custom', 'Inline Radios - custom'],			
    }
  },
  mounted () {
	$('.counterDiv').hide();
	$('.otherOptions').hide();	
  },
  computed: {
        
   },
  methods: {
    validator (val) {
      return val ? val.length >= 4 : false
    },
	back(){
		console.log('call');
		this.$router.push({path:'GPS_lists'})
	}
  }
}
</script>
